import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ProcessResetDto } from '../../api/api-generated';
import { useProcessResetMutation } from '../../api/api-hooks';
import { createValidationMessages, getPasswordStrength } from './authUtils';
import logo from './logoCompressed.webp';

const PasswordReset = () => {
  const { pathname } = useLocation();
  const [formState, setFormState] = useState<ProcessResetDto>({
    token: pathname.slice(16),
    password: '',
  });
  const [message, setMessage] = useState<string>('');
  const [userFeedback, setUserFeedback] = useState<string[]>([]);
  const [reset] = useProcessResetMutation();
  const [passwordScore, setPasswordScore] = useState<number>(0);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { push } = useHistory();
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormState((state) => ({ ...state, [name]: value }));
    setUserFeedback(createValidationMessages(value));
    import('zxcvbn').then((check) => {
      const { score } = check.default(value);
      setPasswordScore(score);
    });
  };
  const handleSubmit = async () => {
    const response = await reset({
      processResetDto: {
        ...formState,
      },
    });
    if ('error' in response)
      setMessage(
        "Sorry, we couldn't change your password. Try requesting another password reset email."
      );
    else setMessage('Password changed.');
  };
  const handleShowPassword = () => {
    setShowPassword((state) => !state);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Grid container direction='column' spacing={2}>
      <Grid item>
        <img src={logo} alt='LP Technologies Logo' />
      </Grid>
      <Grid item>
        <FormControl variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-password'>
            Password
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-password'
            type={showPassword ? 'text' : 'password'}
            value={formState.password}
            onChange={handleChange}
            name='password'
            style={{ width: '400px' }}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'
                  size='large'
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

        <Typography>
          <strong>Password Strength</strong>:{' '}
          {getPasswordStrength(passwordScore)}
        </Typography>
      </Grid>
      {userFeedback.length > 0 && (
        <Grid item>
          {userFeedback.map((error) => (
            <Typography color='error'>{error}</Typography>
          ))}
        </Grid>
      )}
      {message ? (
        <>
          <Grid item>
            <Typography>{message}</Typography>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                push('/login');
              }}
              variant='outlined'
              color='primary'
            >
              To Login Page
            </Button>
          </Grid>
        </>
      ) : (
        <Grid item>
          <Button
            onClick={handleSubmit}
            variant='contained'
            color='primary'
            disabled={
              userFeedback.length !== 0 || formState.password.length < 1
            }
          >
            Submit
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default PasswordReset;
